import React, { useState, useEffect } from 'react';
import  paris from './fotoBosqueJuntos.jpg';
import  fotoBosque from './fotoBosque.jpg';
import  invitacionMejor from './invitacion.png';
import  monogram from './monogramaWhite.png';
import backgroundPaper from './background-paper.png';
import palmsIcon from './palmsIcon.png'
import brideGroomIcon from './brideGroomIcon.png'
import tableIcon from './tableIcon.png'
import dressSuitIcon from './dressSuitIcon.png'
import fotoSentados from './fotoSentados.jpg'
import fotoAcostados from './fotoAcostados.jpg'
import fotoParados from './fotoParados.jpg'
import './App.css';
import './fonts.css';
import { calculateTimeLeft } from './utils/countdown';

function App() {

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer); // Clean up on unmount 
  }, []);

  return (
<div className="App">
  <div className="hero-container">
    <img src={paris} className="hero-image" alt="Paris proposal" />
     <div className="hero-overlay-monogram">
      <img src={monogram} className="hero-monogram" alt="Monogram" />
     </div>
  </div>

  {/* Scroll-down Countdown Section */}
  <section className="countdown-section">
    <h3 className="countdown-label">“El amor hace posible la paradoja de dos que se vuelven uno sin dejar de ser dos”</h3>
    <h1 className="countdown-title">Save Our Date</h1>
    <h3 className="countdown-subtitle">Domingo 08 Noviembre 2026</h3>

    <div className="countdown-grid">
      <div className="countdown-item">
        <div className="countdown-value">{timeLeft.days}</div>
        <div className="countdown-label">Dias</div>
      </div>
      <div className="countdown-item">
        <div className="countdown-value">{timeLeft.hours}</div>
        <div className="countdown-label">Horas</div>
      </div>
      <div className="countdown-item">
        <div className="countdown-value">{timeLeft.minutes}</div>
        <div className="countdown-label">Minutos</div>
      </div>
      <div className="countdown-item">
        <div className="countdown-value">{timeLeft.seconds}</div>
        <div className="countdown-label">Segundos</div>
      </div>
    </div>
  </section>

<div className="hero-container fotoBosque-container">
  <img src={fotoBosque} className="hero-image" alt="fotoBosque" />
</div>

<div className="invitation-section">
  <img src={invitacionMejor} className="invitation-image" alt="sobre" />
</div>

{/* Ceremonia */}
<section className="details-section">
  <h1 className="itinerary-title">Itinerario</h1>

  <div className="details-grid">
    {/* Temporal 
    <div className="event-box">
      <h2 className="sabado-date">Sabado 07 de Noviembre 2026</h2>
      <img src={palmsIcon} alt="Palms" className="itinerary-icon" />
      <h2 className="event-title">Check-in</h2>
      <p className="gift-text">
        Check-in y bienvenida informal<br />
        durante el dia
      </p>
    </div>
    */}

    <div className="event-box">
      <h2 className="domingo-date">Domingo 08 de Noviembre 2026</h2>
      <img src={brideGroomIcon} alt="Ceremonia" className="itinerary-icon" />
      <h2 className="event-title">Ceremonia Civil</h2>
      <p className="gift-text">
        Grand Palladium<br />
        Vallarta Resort & Spa<br />
        17:00 horas
      </p>
    </div>

    <div className="event-box">
      <h2 className="domingo-date">Domingo 08 de Noviembre 2026</h2>
      <img src={tableIcon} alt="Recepción" className="itinerary-icon" />
      <h2 className="event-title">Recepcion</h2>
      <p className="gift-text">
        Grand Palladium<br />
        Vallarta Resort & Spa<br />
        19:00 horas
      </p>
    </div>
  </div>
  <div className="extra-info">
    <p className="countdown-label">
      *Más adelante la wedding planner te contactará para confirmar asistencia.
    </p>
    <p className="dress-code">Dress code: Beach Formal</p>
    <img src={dressSuitIcon} alt="Icono dress code" className="itinerary-icon" />
  </div>
</section>

{/* Segment 3 photos */}
<section className="photo-grid-section">
  <div className="photo-grid">
    <img src={fotoAcostados} alt="Foto 1" className="grid-photo" />
    <img src={fotoParados} alt="Foto 2" className="grid-photo" />
    <img src={fotoSentados} alt="Foto 3" className="grid-photo" />
  </div>
</section>

{/* Mesa de regalo */}
<section className="gift-section">
  <h1 className="gift-title">Mesa de regalos</h1>
  <p className="gift-text">
    Su presencia es el mejor regalo que podemos recibir.<br />
    Pero si desean obsequiarnos algo,<br />
    hemos preparado una lista de regalos con algunas ideas <br />
    que nos serán de gran ayuda en esta nueva etapa.<br />
    ¡Gracias por pensar en nosotros con tanto cariño!<br /> 
    <a 
      href="https://mesaderegalos.liverpool.com.mx/milistaderegalos/60011373"
      target="_blank"
      rel="noopener noreferrer"
    > 
    Liverpool
    </a> No. de evento: 60011373 <br />

    <a 
      href="https://www.amazon.com.mx/wedding/guest-view/SO2T6HQ4LRTR"
      target="_blank"
      rel="noopener noreferrer"
    >
    Amazon
    </a> <br />
  </p>
</section>


{/* Itinerario 
<section className="itinerary-section">
  <h1 className="itinerary-title">Itinerario</h1>

  <div className="itinerary-grid">
    
    <div className="itinerary-box">
      <h2 className="sabado-date">Sábado 07 de Noviembre 2026</h2>
      <img src={palmsIcon} alt="Palms" className="itinerary-icon" />
      <p>Check-in y bienvenida informal<br />durante el día.</p>
    </div>

    
    <div className="domingo-container">
      <h2 className="domingo-date">Domingo 08 de Noviembre 2026</h2>

      <div className="domingo-events">
        <div className="itinerary-box">
          <img src={brideGroomIcon} alt="Ceremonia" className="itinerary-icon" />
          <p>
            <span className="event-heading">Ceremonia Civil</span><br />
            Grand Palladium<br />
            Vallarta Resort & Spa<br />
            18:00 horas
          </p>
        </div>
        <div className="itinerary-box">
          <img src={tableIcon} alt="Recepción" className="itinerary-icon" />
          <p>
            <span className="event-heading">Recepción</span><br />
            Grand Palladium<br />
            Vallarta Resort & Spa<br />
            20:00 horas
          </p>
        </div>
      </div>
    </div>
  </div>

  <p className="dress-code">Dress code: Beach Formal</p>
  <img src={dressSuitIcon} alt="Palms" className="itinerary-icon" />
</section>
*/}

</div>

  );
}

export default App;
